import { useContext, useEffect, useState } from "react"
import Tooltip from '@mui/material/Tooltip';
import { BoardContext, TeamContext } from "../../../context"

import { UpperTokensBar } from "../../atoms";
import PinkNotification from "../Notification/PinkNotification";
import { useTranslation } from "react-i18next";

const DilemmaRoundsCounter = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { instructionTutorial } = useContext(BoardContext);
    const numberOfSolvedDilemmas: number = game?.gameInfo.challengeScore || 0;
    const [isSolvedDilemmaPointActive, setIsSolvedDilemmaPointActive] = useState<boolean>(true);
    const gameRoundNumber: number = game?.gameInfo?.challengeScore || 0;
    const doublePointedRoundNumber: number = 4;
    const isAfterRound3: string = (gameRoundNumber === doublePointedRoundNumber) ? t("+2Text") : t("+1Text");

    useEffect(() => {
        setIsSolvedDilemmaPointActive(true);
    }, [game?.gameInfo.challengeScore]);

    const endUpperCoinAnimation = () => {
        setTimeout(() => {
            setIsSolvedDilemmaPointActive(false);
        }, 2500);
    }

    if (isSolvedDilemmaPointActive) {
        endUpperCoinAnimation();
    }

    return (
        <div className={` number_or_dilemmas_and_counterdown_box  number_of_solverd_dilemmas_wrapper_width ${ instructionTutorial === "rightSideOfTheScreen" && "white_box_shadow"} `}>
            {instructionTutorial === "rightSideOfTheScreen" && <PinkNotification notificationWidthVW={34} notificationRenderingSide="left" text={t("tipYourTeamGoalIsToSolveAsManyDilemmasText")} areDotsPositionedToBottom={true} moveFromTop={0} progressNumber={8} /> }
             <Tooltip title={t("numberOfDilemmasText")} arrow>
                <div className="new_icon_wrappper">
                    <div className="solved_dilemmas_icon"/>
                </div>
            </Tooltip>
            <div className="new_time_countdown_wrappper center_horizontally_and_vertically">
                {<UpperTokensBar numberOfPoints={numberOfSolvedDilemmas+1} />}
            </div>
            {isSolvedDilemmaPointActive && <div className="number_of_solved_dilemmas_plus_one_poin">
                {isAfterRound3}
            </div>}
        </div>
    )
}

export default DilemmaRoundsCounter;